module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "main-content--header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column left"
  }, [_c('router-link', {
    staticClass: "router-link-active",
    attrs: {
      "to": "/admin/settings"
    }
  }, [_c('h4', [_vm._v("Admin Settings")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column right"
  }, [_c('router-link', {
    staticClass: "router-link-active",
    attrs: {
      "to": "/admin"
    }
  }, [_vm._v("\n          Go to Admin Reports\n        ")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [_c('div', {
    staticClass: "panel--top"
  }, [_c('div', {
    staticClass: "m-t-lg"
  }, [_c('h3', {
    staticClass: "text-left text-md m-t-lg"
  }, [_vm._v("Message Style")]), _vm._v(" "), _c('p', {
    staticClass: "text-left text-sm m-t-sm"
  }, [_vm._v("Select how you want your Worklogs messages to display on Slack")]), _vm._v(" "), _c('form', {
    staticClass: "m-t-md",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messagetype),
      expression: "messagetype"
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "name": "question"
    },
    domProps: {
      "checked": _vm._q(_vm.messagetype, "2")
    },
    on: {
      "__c": function($event) {
        _vm.messagetype = "2"
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/img/oneline.png")
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio second-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messagetype),
      expression: "messagetype"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "name": "question"
    },
    domProps: {
      "checked": _vm._q(_vm.messagetype, "1")
    },
    on: {
      "__c": function($event) {
        _vm.messagetype = "1"
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/img/multiline.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control submit m-t-md"
  }, [_c('button', {
    staticClass: "button is-primary save-btn",
    class: {
      'is-disabled': _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Update\n                  "), _c('span', {
    class: {
      'sslack-loader': _vm.sloading
    }
  })])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae230484"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminSetting.vue
// module id = 391
// module chunks = 1